import { FC } from "react"

export type MovieItem2Props = {
  cover?: string
  href?: string
  title?: string
  name?: string
}

export const MovieItem2: FC<MovieItem2Props> = ({ cover, href, title, name }) => {

  return <div className="group overflow-hidden aspect-w-16 aspect-h-9 cursor-pointer transition duration-300 relative">
    <img src={cover} alt="" className="transform group-hover:scale-110 transition duration-300" />
    <div className="absolute inset-0 group-hover:visible transition duration-300">
      <div className="absolute"></div>
      <div className="absolute bottom-0 left-0 right-0 text-white bg-gradient-to-t from-black to-transparent p-2">
        <div className="truncate">{name}</div>
        <div className="text-sm truncate">{title}</div>
      </div>
    </div>
  </div>
}